import { render, staticRenderFns } from "./IframePlayer.vue?vue&type=template&id=878adf64&"
import script from "./IframePlayer.vue?vue&type=script&lang=js&"
export * from "./IframePlayer.vue?vue&type=script&lang=js&"
import style0 from "./IframePlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports